module.exports = __webpack_public_path__ + "img/equip-er.a605cc47.png";